
  import { Vue, Component } from "vue-property-decorator";

  @Component
  export default class Disclosures extends Vue {
    discs = {};
    s;
    items = [
      {
        name: "Michael Crary",
        description:
          "Co-owner FDI; creator of MDTP; MDTP Instructor; Dr. Crary holds the intellectual property rights for both MDTP and Pharyngocise",
      },
      {
        name: "Giselle Carnaby",
        description:
          "Co-owner FDI; creator of MDTP; MDTP Instructor; Dr. Carnaby holds the intellectual property rights for both MDTP and Pharyngocise",
      },
      {
        name: "Sarah Dungan",
        description:
          "MDTP Instructor; Ms. Dungan receives an honorarium from FDI for teaching courses",
      },
      {
        name: "Kendrea Garand",
        description:
          "MDTP Instructor; Dr. Garand receives an honorarium from FDI for teaching courses",
      },
      {
        name: "Jessica Gregor",
        description:
          "MDTP Instructor; Ms. Gregor receives an honorarium from FDI for teaching courses",
      },
      {
        name: "Lisa LaGorio",
        description:
          "MDTP Instructor; FDI Continuing Education Administrator (CEA); Dr. LaGorio receives an honorarium from FDI for teaching courses and for serving as the CEA",
      },
      {
        name: "Diane Longnecker",
        description:
          "MDTP Instructor; Dr. Longnecker receives an honorarium from FDI for teaching courses",
      },
      {
        name: "Yvette McCoy",
        description:
          "MDTP Instructor; Dr. McCoy receives an honorarium from FDI for teaching courses",
      },
    ];
  }
